export default __webpack_public_path__ + "static/media/generic.8973ad91.png";